import React, { Fragment } from 'react';
//@ts-ignore
// import Fade from 'react-reveal/Fade';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import { ArrowDown, ArrowBarDown, ArrowRightCircle } from 'react-bootstrap-icons'
import styles from './HardCodedMainPage.module.css';
import { Parallax } from 'react-parallax';
import { HomepageImpact } from './HomepageImpact/HomepageImpact';
import { homepageHowItWorksData, HowItWorksItem, menuItems, MenuItems} from './HomepageData';
import { HomepageCard } from './HomepageCard/HomepageCard';
import { MenuCard } from './MenuCard/MenuCard'

type HardCodedMainPageProps = {
	a: () => void
}

// type HeaderCard = {
// 	header: string,
// 	image: string,
// 	blurb: string,
// 	link: string,
// 	x?: number,
// 	y?: number
// }

// const headerCards: HeaderCard[] = [
// 	{
// 		header: "Lorem Ipsum",
// 		image: "https://2019.igem.org/wiki/images/a/a9/T--Washington--Octet_Sensor_Setup.png",
// 		blurb: "Lorem ipsum",
// 		link: ""
// 	}
// ]


const MelInfoSrc = () => { 
	return (
		<div id={styles.citationBox} className={styles.citeAction}>
			<div id={styles.citation}>
				<p>The Skin Cancer Foundation. (2022, May 24). <em>Skin cancer facts &amp; statistics</em>. The Skin Cancer Foundation. Retrieved October 9, 2022,</p>
				<p>&emsp;&emsp;from https://www.skincancer.org/skin-cancer-information/skin-cancer-facts/#:~:text=In%20the%20past%20decade%20(2012,</p>
				<p>&emsp;&emsp;annually%20increased%20by%2031%20percent.&amp;text=An%20estimated%207%2C650%20people%20will,and%202%2C570%20</p>
				<p>&emsp;&emsp;will%20be%20women.&amp;text=The%20vast%20majority%20of%20melanomas%20are%20caused%20by%20the%20sun.</p>
			</div>
		</div>
	)
}

let paragraphs: string[] = [
	'Our project is to combat melanoma by targeting both early diagnosis and late stage therapeutics. For early diagnosis, we have worked to develop an accessible and noninvasive diagnostic for melanoma. Our diagnostic tool is a loop-mediated isothermal amplification, or LAMP, assay envisioned to be a diagnostic aid to clinicians to help detect melanoma in its early stages. Additionally, our project also focuses on the development of novel peptide therapeutics for treatment of advanced melanoma that has undergone metastasis.',
	'Early diagnosis of melanoma is critical. This is because localized melanoma is easily survivable in 99% of cases but by the time it has begun to spread, five year survivability drops to 68%, and then after distant spreading, to 33% [1]. This behavior makes an efficient diagnostic tool incredibly important and relevant, inspiring our team to create a melanoma diagnostic.',
	'The critical need for a novel diagnostic becomes even more clear when considering the multitude of reasons why it is difficult for people to get a melanoma diagnosis. One of the main reasons is cost. In the United States, healthcare, including dermatology services, can be extremely expensive. Additionally, it can take anywhere from weeks to months for someone to get a dermatology appointment as dermatologists are often highly booked in the U.S. The high costs and inaccessibility of care dissuade patients from seeking testing.',
	'The current way that melanoma is usually detected is through biopsy. Biopsies can be invasive and there are many reasons why patients might not feel comfortable getting a biopsy. The invasiveness of biopsies also makes doctors hesitant to biopsy any moles that they do not think are likely to be melanoma.',
	'To remedy this issue, we envisioned getting our diagnostic samples using a skin patch, a relatively less invasive method compared to biopsy. This idea was inspired by multiple sources, though a primary energizer was the company DermTech, which developed an adhesive skin patch to obtain samples for their melanoma diagnostic tool [2] [3]. Beyond DermTech, other brands such as D-squame offer skin sample collection patches, as well, making them easily accessible to the general public [4].',
	'Collected skin DNA samples would then be applied to our diagnostic. Current diagnostic methods rely on sequencing for detection of genetic biomarkers. However, that requires a bulky PCR machine which is inaccessible to both of our primary target stakeholders, the general public and rural clinics. Thus, we decided to develop a point-of-care LAMP-based diagnostic which can be more accessible and interpretable.',
	'While researching melanoma, we also discovered a need for more therapeutics that target late-stage melanoma, when the cancer has already metastasized and biopsies are ineffective. As a result, we have decided to design cell penetrating peptides to target and inhibit melanoma biomarkers. Specifically, our project aims to inhibit mutant BRAF, NRAS, and ERK, which are three proteins of mitogen-activated protein kinase (MAPK) signaling pathway that regulates cell proliferation and cell growth [5]. Mutations in the MAPK pathway can lead to uncontrolled cell growth, leading to the formation of melanoma [5]. Our goal for the therapeutics part of our project is to use computational protein modeling to design three cell penetrating peptides that will bind to NRAS, BRAF, and ERK.',
	'[1] American Cancer Society. Cancer Facts & Figures 2022. Atlanta, Ga: American Cancer Society; 2022.',
	'[2] DermTech. (2022). Retrieved October 8, 2022, from https://dermtech.com/ ',
	'[3]Wachsman, W., Morhenn, V., Palmer, T., Walls, L., Hata, T., Zalla, J., Scheinberg, R., Sofen, H., Mraz, S., Gross, K., Rabinovitz, H., Polsky, D., & Chang, S. (2011). Noninvasive genomic detection of melanoma. The British journal of dermatology, 164(4), 797–806. https://doi.org/10.1111/j.1365-2133.2011.10239.x',
	'[4] D100 - D-Squame standard sampling discs. Clinical and Derm LLC. (n.d.). Retrieved October 8, 2022, from https://clinicalandderm.com/d100-d-squame-standard-sampling-discs/ ',
	'[5] Proietti, I., Skroza, N., Michelini, S., Mambrin, A., Balduzzi, V., Bernardini, N., Marchesiello, A., Tolino, E., Volpe, S., Maddalena, P., Di Fraia, M., Mangino, G., Romeo, G., & Potenza, C. (2020). BRAF Inhibitors: Molecular Targeting and Immunomodulatory Actions. Cancers, 12(7), 1823. https://doi.org/10.3390/cancers12071823'
]

export const HardCodedMainPage: React.FC<HardCodedMainPageProps> = ({
	a
}) => {
	return <>
		<article className={styles.homepage}>
			<div className={styles.heroScreen} />
			<div className={styles.heroImage} />
			<section className={styles.heroContainer}>
				<Container className={styles.hero}>
					<Row>
						<Col md={9}>
							<h1>MELANOMA DIAGNOSTIC</h1>
							<p>Utilizing loop-mediated isothermal amplification methods for a melanoma diagnostic test</p>
						</Col>
					</Row>
				</Container>
				<div className={styles.scrollDown}>
					<p>scroll down for more information</p>
					<ArrowDown size={24} />
				</div>
			</section>
			<section id={styles.promoVideoContainer}>
				<div id={styles.promoVideoBackground}>
					<iframe id={styles.promoVideo} title="Washington: Melanoma Detection and Therapy (2022) - Project Promotion [English]" width="560" height="315" src="https://video.igem.org/videos/embed/77f7fd49-df66-48e7-b787-af3ea9eff927" frameBorder="0" allowFullScreen={true} sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
				</div>
			</section>
			<section className={styles.problemContext}>
				<div id={styles.problemScreen} />
				<div id={styles.problemContent}>
					<Container id={styles.factsContainer}>
						<div id={styles.problemHead}>
							<h1>MELANOMA</h1>
							<h2>what is it?</h2>
						</div>
						<div id={styles.melanomaImgs}>
							<img src={'https://static.igem.wiki/teams/4441/wiki/main-page-images/melanoma-structure.jpg'}
								style={{
									gridRow: "2 / end",
									gridColumn: 1
								}}/>
							<img src={'https://static.igem.wiki/teams/4441/wiki/main-page-images/sun.jpg'}
								style={{
									gridRow: "1 / 3",
									gridColumn: 2
								}}/>
						</div>
						<div id={styles.facts} className={styles.citeAction}>
							<div 
								id={styles.fact1}
								className={styles.factBox}
								style={{
									gridColumn: 1,
									gridRow: 1
								}}>
								<p style={{alignSelf: 'start'}}>a form of</p>
								<h2 style={{alignSelf: 'end'}}>Skin Cancer</h2>
							</div>
							<div className={styles.factBox}
								style={{
									gridColumn: 2,
									gridRow: 2
								}}>
								<p style={{alignSelf: 'start'}}>cause of</p>
								<h2>7650 Deaths</h2>
								<p style={{alignSelf: 'end'}}>annually</p>
							</div>
							<div className={styles.factBox}
								style={{
									gridColumn: 3,
									gridRow: 3
								}}>
								<p style={{alignSelf: 'start'}}>caused by</p>
								<h2>UV Radiation</h2>
								<p style={{alignSelf: 'end'}}>exposure</p>
							</div>
						</div>
					</Container>
					<a href='https://2022.igem.wiki/washington/description' target={"_blank"}>
						<div id={styles.moreFacts}>
							<p>More Information</p>
							<ArrowRightCircle size={24}/>
						</div>
					</a>
				</div>
				<MelInfoSrc />
			</section>
			<section className={styles.ourSolution}>
				<div id={styles.solutionScreen} />
				<div id={styles.solutionWhole}>
					<div id={styles.containerTop}>
						<div className={styles.topBar} style={{gridColumn: 1}} />
						<h1 style={{gridColumn: 2, textAlign: 'center'}}>Our Project</h1>
						<div className={styles.topBar} style={{gridColumn: 3}} />
					</div>
					<div id={styles.solutionContainer}>
						{
							paragraphs.map(p => {
								return <p>&emsp;&emsp;{p}</p>
							})
						}
					</div>
				</div>
			</section>
			<section className={styles.menu}>
					{
						[0,1,2].map(i => {
							return (
								<Row key={'row-' + i} className={styles.row}>
									{
										[0,1].map(j => {
											{console.log(menuItems[i*2 + j].x)}
											return (
												<MenuCard key={'card-' + (i*2 + j)}
														section={menuItems[i*2 + j].section}
														link={menuItems[i*2 + j].link}
														image={menuItems[i*2 + j].image}
														x={menuItems[i*2 + j].x}
														y={menuItems[i*2 + j].y}
														zoom={menuItems[i*2 + j].zoom}
														/>
											)
										})
									}
								</Row>
							)
						})
					}
			</section>
		</article>
	</>
}
